// Radio Inputs
export default (h, field, errorMessages, value, onInput, onBlur, onFocus, self) => {
  console.log('Radio Field')

  const radios = field.values.map(value => (
    <v-radio
      label={value.label}
      value={value.value}
      class={field.attributes.class}
    ></v-radio>
  ))

  return (
    <div class="input--radio--row__wrapper">
      <div class="v-label input--radio__label">{field.attributes.label}</div>
      <v-radio-group
        class={field.attributes.class}
        value={value}
        onChange={onInput}
        row
      >
        {radios}
      </v-radio-group>
    </div>
  )
}
